"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@angular/core");
class XsSizeableDirective {
    constructor(element) {
        this.element = element;
        this.nodes = [];
        this.limit = 50;
        this.sizeable = true;
        this.mousemove = this.mousemove.bind(this);
        this.mouseup = this.mouseup.bind(this);
    }
    mousemove(e) {
        if (this.data) {
            var { height, width, top, left } = this.data.rect;
            var style = this.element.nativeElement.style;
            var offset_y = this.data.y - e.clientY;
            var offset_x = this.data.x - e.clientX;
            var set = {};
            switch (this.data.direction) {
                case 'top':
                    set.height = height + offset_y;
                    set.top = top - offset_y;
                    break;
                case 'bottom':
                    set.height = height - offset_y;
                    break;
                case 'left':
                    set.width = width + offset_x;
                    set.left = left - offset_x;
                    break;
                case 'right':
                    set.width = width - offset_x;
            }
            if (set.width < this.limit) {
                delete set.width;
                delete set.left;
            }
            if (set.height < this.limit) {
                delete set.height;
                delete set.top;
            }
            Object.entries(set).forEach(([name, value]) => {
                style[name] = value + 'px';
            });
        }
    }
    createNode(side) {
        var node = document.createElement('div');
        node.classList.add('reborder-' + side, 'reborder');
        this.element.nativeElement.appendChild(node);
        this.nodes.push(node);
    }
    ngOnInit() {
        ['left', 'bottom'].forEach(this.createNode.bind(this)); // ['top', 'left', 'right', 'bottom']
        window.addEventListener('mousemove', this.mousemove);
        this.element.nativeElement.classList.add('resize');
        window.addEventListener('mouseup', this.mouseup);
    }
    mousedown(e) {
        if (e.target.classList.contains('reborder') && this.sizeable) {
            var rect = this.element.nativeElement.getBoundingClientRect();
            this.data = {
                x: e.clientX,
                y: e.clientY,
                rect,
                direction: e.target.className.match(/reborder-([^ ]+)/)[1]
            };
            e.preventDefault();
        }
        else {
            delete this.data;
        }
    }
    mouseup(e) {
        delete this.data;
    }
    ngOnDestroy() {
        this.nodes.forEach(n => n.remove());
        window.removeEventListener('mousemove', this.mousemove);
        window.removeEventListener('mouseup', this.mouseup);
    }
}
exports.XsSizeableDirective = XsSizeableDirective;
/*
@Directive({
  selector: '[fdmDraggable]'
})
class DraggableDirective implements onInit, onDestroy {
  private element: HTMLElement;
  private handlerNode: HTMLElement;
  private data: {x: number, y: number};
  
  @Input('draggable')
  private handler: string;
  
  @HostListener('mousedown', ['$event'])
  mousedown(e) {
      if (e.target === this.handlerNode) {
          var rect = this.element.getBoundingClientRect();
          this.data = {
              x: e.clientX - rect.left,
              y: e.clientY - rect.top
          };
      } else {
          delete this.data;
      }
  }
  
  @HostListener('document:mouseup', ['$event'])
  mouseup(e) {
      delete this.data;
  }
  constructor(@Inject(ElementRef) element: ElementRef) {
      this.element = element.nativeElement;
  }
  ngOnInit() {
      this.element.classList.add('dragabble');
      this.handlerNode = this.element.querySelector(this.handler);
  }
  
  @HostListener('document:mousemove', ['$event'])
  onPointerMove(e: PointerEvent): void {
      if (this.data) {
          var x = e.clientX - this.data.x;
          var y = e.clientY - this.data.y;
          this.element.style.left = x + 'px';
          this.element.style.top = y + 'px';
      }
  }
  ngOnDestroy() {
      // this.nodes.forEach(n => n.remove());
      window.removeEventListener('mousemove', this.mousemove);
      window.removeEventListener('mouseup', this.mouseup);
  }
}
*/ 
